import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_7579_114793)"
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = {
  id: "clip0_7579_114793"
};
const _hoisted_5 = ["width", "height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.width,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M10.6692 5.33203V3.33203L12.6692 1.33203L13.3359 2.66536L14.6692 3.33203L12.6692 5.33203H10.6692ZM10.6692 5.33203L8.00258 7.99866M14.6693 \n                7.9987C14.6693 11.6806 11.6845 14.6654 8.0026 14.6654C4.32071 14.6654 1.33594 11.6806 1.33594 7.9987C1.33594 4.3168 4.32071 1.33203 8.0026 \n                1.33203M11.3359 7.9987C11.3359 9.83965 9.84355 11.332 8.0026 11.332C6.16166 11.332 4.66927 9.83965 4.66927 7.9987C4.66927 6.15775 6.16166 \n                4.66536 8.0026 4.66536",
    stroke: $props.color,
    "stroke-width": "1.4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, 8, _hoisted_3)]), _createElementVNode("defs", null, [_createElementVNode("clipPath", _hoisted_4, [_createElementVNode("rect", {
    width: $props.width,
    height: $props.height,
    fill: "white"
  }, null, 8, _hoisted_5)])])], 8, _hoisted_1);
}